import { render, staticRenderFns } from "./AddReferences.vue?vue&type=template&id=7ad39b1c&scoped=true&"
import script from "./AddReferences.vue?vue&type=script&lang=js&"
export * from "./AddReferences.vue?vue&type=script&lang=js&"
import style0 from "./AddReferences.vue?vue&type=style&index=0&id=7ad39b1c&lang=scss&scoped=true&"
import style1 from "./AddReferences.vue?vue&type=style&index=1&id=7ad39b1c&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad39b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad39b1c')) {
      api.createRecord('7ad39b1c', component.options)
    } else {
      api.reload('7ad39b1c', component.options)
    }
    module.hot.accept("./AddReferences.vue?vue&type=template&id=7ad39b1c&scoped=true&", function () {
      api.rerender('7ad39b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/modals/FieldReferenceBook/AddReferences.vue"
export default component.exports